<!--
    系统中心-角色权限
    作用：教学平台、校区管理后台、课件器管理后台的角色权限
    功能：展示/新增/编辑角色权限
    组件:AppList
-->
<template>
  <div class="role">
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      api="/api/service/operate/role">
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="160px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="edit(scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
export default {
  name: 'Role',
  data() {
    return {
      list: {},
      columns: [
        { prop: 'name', label: '角色名称' },
        { prop: 'created_at', label: '创建时间' },
      ],
    };
  },
  methods: {
    edit(row) {
      this.$router.push(`/role/detail/${row.id}/${row.name}`);
    },
  },
};
</script>

<style scoped lang="scss">
.role {
  /deep/ .list-header {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Role/index.vue